export default "__VITE_ASSET__0b5b7018__"